<script>
    import { VSPNFOOTERMENU } from '../../constants/FooterMenuContants'

    export default {
        name: 'VspnFooter',
        data () {
            return {
                copyrightYear: new Date().getFullYear(),
                menu: VSPNFOOTERMENU
            }
        }
    }
</script>

<template>
    <footer id="footer">
        <div class="container">
            <!--  content copyright  -->
            <div class="center-block text-center CopyrightImg"></div>
            <div class="more box boxeffect">
                <p style="font-weight:200; margin-bottom:10px"><strong>Friendly Reminder to Our Colleagues:</strong>
                Use of VIN content is limited to personal reference by VIN members. No portion of any VIN content may be copied or distributed without the expressed written permission of VIN.</p>
                <p style="font-weight:200; margin-bottom:10px">Clinicians are reminded that you are ultimately responsible for the care of your patients. Any content that concerns treatment of your cases should be deemed recommendations by colleagues for you to consider in your case management decisions. Dosages should be confirmed prior to dispensing medications unfamiliar to you. To better understand the origins and logic behind these policies, and to discuss them with your colleagues, <a href="/doc/?id=27281&useobjecttypeid=15">click here.</a></p>
                <p style="font-weight:200; margin-bottom:10px">Images posted by VIN community members and displayed via VIN should not be considered of diagnostic quality and the ultimate interpretation of the images lies with the attending clinician.  Suggestions, discussions and interpretation related to posted images are only that -- suggestions and recommendations which may be based upon less than diagnostic quality information.</p>
            </div>           
            <!--  /content copyright  -->
            <div class="row">
                <div
                    v-if="!!menu.siteMap.active"
                    class="col-xs-3 col-sm-3 col-md-3"
                >
                    <h3 class="footer-column-title">{{ menu.siteMap.title }}</h3>
                    <ul class="footer-menus">
                        <template v-for="(item, index) in menu.siteMap.links">
                            <li v-if="!!item.display" :key="index">
                                <a
                                    v-if="!!item.url"
                                    :href="item.url"
                                    :target="[!!item.target ? item.target : '']">
                                    {{ item.text }}
                                </a>
                                <span v-else>{{ item.text }}</span>
                            </li>
                        </template>
                    </ul>
                </div>
                <div
                    v-if="!!menu.help.active"
                    class="col-xs-6 col-sm-2 col-md-2"
                    style="padding:0;"
                >
                    <h3 class="footer-column-title">{{ menu.help.title }}</h3>
                    <ul class="footer-menus">
                        <template v-for="(item, index) in menu.help.links">
                            <li v-if="!!item.display" :key="index">
                                <a
                                    v-if="!!item.url"
                                    :href="item.url"
                                    :target="[!!item.target ? item.target : '']">
                                    {{ item.text }}
                                </a>
                                <span v-else>{{ item.text }}</span>
                            </li>
                        </template>
                    </ul>
                </div>
                <div class="col-xs-6 col-sm-5 col-md-3 contact-container">
                    <h3 class="footer-column-title">{{ menu.contact.title }}</h3>
                    <template v-for="(item, index) in menu.contact.links">
                        <p
                            v-if="!!item.display"
                            :key="index"
                        >
                            <a
                                v-if="!!item.url"
                                :href="item.url"
                                :target="[!!item.target ? item.target : '']"
                            >
                                {{ item.text }}
                            </a>
                            <template v-else>{{ item.text }}</template>
                        </p>
                    </template>
                </div>
                <div class="col-xs-12 col-sm-4 col-md-3 col-lg-2 phone-container" style="min-width:290px;">
                    <h3>PHONE</h3>
                    <ul class="contact-list">
                        <li>
                            <img src="/global/images/icon/US.png"/>
                            <span class="b">Toll Free:</span>
                            <span class="phone">800-846-0028<br />ext 791</span>
                        </li>
                        <li>
                            <img src="/global/images/icon/UK.png"/>
                            <span class="b">From UK:</span>
                            <span class="phone">01-45-222-6154</span>
                        </li>
                        <li>
                            <span class="b">From anywhere:</span>
                            <span class="phone">(1)-530-756-4881</span>
                        </li>
                        <li>
                            <img src="/global/images/icon/Australia.png"/>
                            <span class="b">From Australia:</span>
                            <span class="phone">02-6145-2357</span>
                        </li>
                    </ul>
                    <div class="clearfix"></div>
                    <div class="follow" style="display:none">
                        <h3>FOLLOW VIN</h3>
                        <div class="social">
                            <a href="https://www.facebook.com/" class="icon-facebook" target="_blank"></a>
                            <a href="https://twitter.com/" class="icon-twitter" target="_blank"></a>
                            <a href="https://plus.google.com/" class="icon-google-plus" target="_blank"></a>
                        </div><!--.social-->
                    </div>
                </div>
                <div class="clearfix"></div>
                <div class="col-xs-12">
                    <div class="copyright">
                          <i><a href="/AppUtil/document/default.aspx?id=4732871" target="_blank" class="hidden-xs">Copyright</a>
                           1991-{{ copyrightYear }} Veterinary Information Network, Inc.</i>
                    </div>
                </div>
            </div><!--.row-->
        </div>
    </footer>
</template>

<style lang="scss" scoped>
    .footer-column-title {
        text-transform: uppercase;
    }
</style>